import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-xprinter-thermal' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

export interface IXprinterThermal {
  isConnected: () => Promise<boolean>;
  rebindService: () => Promise<any>;
  connectNet: (ip: string, port: number) => Promise<void>;
  connectBle: (bleAddress: string) => Promise<void>;
  disconnect: () => Promise<void>;
  addEmptyLine: () => void;
  addText: (content: string) => void;
  addBarcode: (content: string, width: number, height: number) => void;
  addQRcode: (content: string, width: number) => void;
  print: () => Promise<string>;
}

export const XprinterThermal: IXprinterThermal = NativeModules.XprinterThermal
  ? NativeModules.XprinterThermal
  : new Proxy(
    {},
    {
      get() {
        throw new Error(LINKING_ERROR);
      },
    }
  );
